/**
 * @file window-event.js
 * @description window事件
 */

/**
 * 打开新窗口
 *
 * @param {*} url 页面链接
 * @param {*} target 打开类型
 */
export const openNewWindow = (url, target = '_target') => {
    window.open(url, target);
};

/**
 * 当前页打开
 *
 * @param {*} url 页面链接
 */
export const openInCurrentPage = url => {
    window.location.assign(url);
};

/**
 * 添加事件
 *
 * @param {*} element 操作元素
 * @param {stirng} type 事件类型
 * @param {Function} handler 事件处理函数
 */
export const addEvent = (element, type, handler) => {
    if (element.addEventListener) {
        // 事件类型、需要执行的函数、是否捕捉
        element.addEventListener(type, handler, false);
    }
    else if (element.attachEvent) {
        element.attachEvent('on' + type, function () {
            handler.call(element);
        });
    }
    else {
        element['on' + type] = handler;
    }
};

/**
 * 移除事件
 *
 * @param {*} element 操作元素
 * @param {string} type 事件类型
 * @param {Function} handler 事件处理函数
 */
export const removeEvent = (element, type, handler) => {
    if (element.removeEventListener) {
        element.removeEventListener(type, handler, false);
    }
    else if (element.detachEvent) {
        element.detachEvent('on' + type, handler);
    }
    else {
        element['on' + type] = null;
    }
};

export const openWebview = url => {
    openNewWindow(url);
};
